var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ruler-listY-box"},_vm._l((300),function(index){return _c('li',{key:index,class:[{ long: index % 10 === 0 }]})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }